<!-- via https://codepen.io/jh3y/pen/aQomdd -->
<template>
	<div class="pie">
		<div
			v-for="(part, i) in src"
			class="pie__segment"
			:style="`
				--offset: ${ offset(src, i) };
				--value: ${ part.percent };
				--bg: ${ part.color };
				--over50: ${ part.percent > 50 ? 1 : 0 };
			`"
		/>
	</div>
</template>

<script>

export default {

	props: {
		src: {
			type: Array,
			default () {
				return [
					{
						percent: 50
					},
					{
						percent: 50
					}
				]
			}
		}
	},
	computed: {
		
	},

	methods: {
		offset (src, i) {
			const reducer = (accumulator, currentValue, index) => index < i ? accumulator + currentValue : accumulator + 0
			return src.map(el => el.percent).reduce(reducer, 0)
		}
	},

	mounted () {
		
	}
}

</script>

<style scoped>

.pie {
  border-radius: 100%;
  height: calc(var(--size, 160) * 1px);
  overflow: hidden;
  margin: 0 auto 20px auto;
  position: relative;
  width: calc(var(--size, 160) * 1px);
  z-index: 1;
	height: 100px;
	width: 100px;
}
.pie__segment {
  --a: calc(var(--over50, 0) * -100%);
  --b: calc((1 + var(--over50, 0)) * 100%);
  --degrees: calc((var(--offset, 0) / 100) * 360);
  -webkit-clip-path: polygon(var(--a) var(--a), var(--b) var(--a), var(--b) var(--b), var(--a) var(--b));
  clip-path: polygon(var(--a) var(--a), var(--b) var(--a), var(--b) var(--b), var(--a) var(--b));
  height: 100%;
  position: absolute;
  -webkit-transform: translate(0, -50%) rotate(90deg) rotate(calc(var(--degrees) * 1deg));
          transform: translate(0, -50%) rotate(90deg) rotate(calc(var(--degrees) * 1deg));
  -webkit-transform-origin: 50% 100%;
          transform-origin: 50% 100%;
  width: 100%;
  z-index: calc(1 + var(--over50));
}
.pie__segment:after,
.pie__segment:before {
  background: var(--bg, #e74c3c);
  content: '';
  height: 100%;
  position: absolute;
  width: 100%;
}
.pie__segment:before {
  --degrees: calc((var(--value, 45) / 100) * 360);
  -webkit-transform: translate(0, 100%) rotate(calc(var(--degrees) * 1deg));
          transform: translate(0, 100%) rotate(calc(var(--degrees) * 1deg));
  -webkit-transform-origin: 50% 0%;
          transform-origin: 50% 0%;
}
.pie__segment:after {
  opacity: var(--over50, 0);
}

</style>
